// 矩阵
import Layout from "@/layout/layout.vue";

const matrix = {
    // 加载路径
    path:"/matrix",
    // 加载组件
    component:Layout,
    // 重定向路径
    redirect:"noRedirect",
    // 路由名称
    name:"矩阵管理",
    children:[
        {
            path:"config",
            name:"矩阵管理",
            component: ()=>import("@/views/matrix/config/index.vue"),
            meta:{title:"矩阵管理",noCache:true}
        },
        {
            path:"vendorManagement",
            name:"厂商管理",
            component: ()=>import("@/views/matrix/vendorManagement/index.vue"),
            meta:{title:"厂商管理",noCache:true}
        },
        {
            path:"fault",
            name:"订单识别中心",
            component: ()=>import("@/views/matrix/fault/index.vue"),
            meta:{title:"订单识别中心",noCache:true}
        },
        {
            path:"outMatrixconfig",
            name:"外部渠道矩阵配置",
            component: ()=>import("@/views/matrix/outMatrixconfig/index.vue"),
            meta:{title:"外部渠道矩阵配置",noCache:true}
        }
    ]
}

export default matrix;
